import styles from './Skeleton.module.scss'

/**
 * Skeleton — shimmer placeholder for async-loading content.
 *
 * Intended for small, contained areas (image thumbs, data cells).
 * For full-screen loading use the pulsing logo `Loading` component instead.
 *
 * Size is controlled entirely by the parent — the skeleton fills 100% width/height
 * of its container. Set a fixed height or aspect-ratio on the parent or pass `className`.
 *
 * @param {object}  props
 * @param {string} [props.className] - Extra class (e.g. to set aspect-ratio or dimensions)
 */
export function Skeleton({ className }) {
  return (
    <div
      className={[styles.skeleton, className].filter(Boolean).join(' ')}
      aria-hidden="true"
    />
  )
}
